<!-- Input Text Template -->
<ng-template #input_text_template>
  <input #inputElement
    id="{{ name }}"
    [attr.aria-labelledby]="name + '_label'"
    type="{{ inputType }}"
    [class]="inputClass"
    formControlName="{{ name }}"
    [autofocus]="autofocus"
    [disableControl]="disabled"
    [placeholder]="placeholder | translate"
         [ngClass]="{
          'ng-invalid': control.invalid && control.touched,
          'ng-dirty': control.invalid && control.touched
         }"
    (keyup)="keyup.emit($event)"
    (change)="valueChange.emit($event)"
    pInputText />
</ng-template>
<!-- Text Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    @if (!inputGroup) {
      <ng-container *ngTemplateOutlet="input_text_template"></ng-container>
    } @else {
      <div medsurf-design-content-input-group>
        <ng-container *ngTemplateOutlet="input_text_template"></ng-container>
        <ng-content></ng-content>
      </div>
    }
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}